// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8efb0468","970":"26d03a31"}[chunkId] + ".chunk.js";
};